var $823d3238faad3ffb$exports = {};
const $823d3238faad3ffb$var$hoursEl = document.querySelector(".hours");
const $823d3238faad3ffb$var$minutesEl = document.querySelector(".minutes");
const $823d3238faad3ffb$var$secondsEl = document.querySelector(".seconds");
const $823d3238faad3ffb$var$messageEl = document.querySelector(".message");
const $823d3238faad3ffb$var$buttonEl = document.querySelector(".button");
let $823d3238faad3ffb$var$total = 3600;
$823d3238faad3ffb$var$buttonEl.addEventListener("click", ()=>{
    $823d3238faad3ffb$var$total -= 60;
});
const $823d3238faad3ffb$var$reverseTimer = setInterval(()=>{
    if ($823d3238faad3ffb$var$total <= 1800) $823d3238faad3ffb$var$messageEl.textContent = "Half time passed";
    if ($823d3238faad3ffb$var$total <= 0) {
        clearInterval($823d3238faad3ffb$var$reverseTimer);
        $823d3238faad3ffb$var$messageEl.textContent = "END";
        return;
    }
    $823d3238faad3ffb$var$total -= 1;
    const hours = Math.floor($823d3238faad3ffb$var$total % 86400 / 3600);
    const minutes = Math.floor($823d3238faad3ffb$var$total % 3600 / 60);
    const seconds = $823d3238faad3ffb$var$total % 60;
    $823d3238faad3ffb$var$hoursEl.textContent = seconds < 10 ? "0" + minutes : hours;
    $823d3238faad3ffb$var$minutesEl.textContent = seconds < 10 ? "0" + minutes : minutes;
    $823d3238faad3ffb$var$secondsEl.textContent = seconds < 10 ? "0" + seconds : seconds;
}, 1000);


//# sourceMappingURL=JS4-HW11.2bead112.js.map
